import { Box, Button, Grid, Theme, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";

import GvOpenAppModal from "../../components/GvOpenAppModal/GvOpenAppModal";
import { LayoutOnboarding } from "../../components";
import { PAGES_PATH } from "../../navigation/params";
import { useGTM } from "../../hooks/useGTM";
import { useLogIn } from "../../services/user/user.service";
import { useNavigate } from "react-router-dom";
import { useUserStatusStore } from "../../hooks/redux-hooks/user-status/user-status.store";

const Landing = () => {
  const navigate = useNavigate();
  const { emailSignIn } = useUserStatusStore();
  const { dispatchEvent } = useGTM();
  const { logInResponse, userStatus } = useLogIn();

  const goToCreateAccount = () => {
    navigate(PAGES_PATH.SIGN_UP);
  };

  const goToExistingUser = () => {
    navigate(PAGES_PATH.SIGN_IN);
  };


  useEffect(() => {
    const url = new URL(window.location.href);
    const city = url.searchParams.get("city");
    const clinic = url.searchParams.get("clinic");

    if (city && clinic) {
      dispatchEvent({
        eventName: "existing_account_login",
        eventProps: {
          city: city?.toLowerCase(),
          clinic: clinic?.toLowerCase(),
        },
      });
    }
  }, []);

  useEffect(() => {
    if (logInResponse) {
      dispatchEvent({
        eventName: "gv_login",
        eventProps: {
          email: emailSignIn,
        },
      });
      if (!userStatus?.profile?.location) {
        navigate(PAGES_PATH.PROFILE_COMPLETION, { replace: true });
      } else {
        navigate(PAGES_PATH.DASHBOARD, { replace: true });
      }
    }
  }, [logInResponse]);

  const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  return (
    <>
      <LayoutOnboarding leftContainerClass={"pt-[5%] 2xl:pt-[10%]"} image="/assets/icons/welcome_screen.jpg">
        <Box className="flex flex-col gap-4">
          <Box className="hidden md:block">
            <img src="/assets/icons/logo_black.svg" alt="GoodVets" className="h-10 my-5" />
          </Box>
          <Typography
            variant="h1"
            gutterBottom
            mt={1}
            className="!font-bold !text-4xl"
          >
            Welcome to GoodVets
          </Typography>
          <Typography variant="body1" className="!text-lg" lineHeight={28}>
            Your pet’s care simplified. Manage appointments, get real-time
            notifications, and track your pet&#39;s care in the GoodVets app.
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            mt={"1rem"}
          >
            <Box className="flex flex-col w-full my-2 gap-4">
              <Button className="!capitalize !font-semibold" onClick={goToExistingUser}>
                Log In
              </Button>
              <Button
                onClick={goToCreateAccount}
                variant="text"
                className="!capitalize font-semibold"
              >
               Create account
              </Button>
            </Box>
          </Grid>
        </Box>
      </LayoutOnboarding>
      {!isLargeScreen && <GvOpenAppModal />}
    </>
  );
};

export default Landing;
